import React from 'react';
import { FEED_PUSHER_SETTING } from '../../../constants';

const DropdownListInvalidateOdds = (props) => (
  <div className="dropdown__list">
    <div
      className={`dropdown__list-item
                    ${props.league.invalidateOdds === FEED_PUSHER_SETTING.INVALIDATE_ODDS.ENABLED_MANUALLY ? 'active' : ''}
                  `}
      onClick={props.handleInvalidateOddsChange.bind(this, props.league.leagueId,
        FEED_PUSHER_SETTING.INVALIDATE_ODDS.ENABLED_MANUALLY)}
    >
      Enabled Manually
    </div>
    <div
      className={`dropdown__list-item
                  ${props.league.invalidateOdds === FEED_PUSHER_SETTING.INVALIDATE_ODDS.NO ? 'active' : ''}
                `}
      onClick={props.handleInvalidateOddsChange.bind(this, props.league.leagueId,
        FEED_PUSHER_SETTING.INVALIDATE_ODDS.NO)}
    >
      No
    </div>
  </div>
);
export default DropdownListInvalidateOdds;
